import React, { useEffect } from 'react';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import SomaDS from '@soma/ds';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Authorization from 'core/Authorization';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Theme from 'xpi-black-ui/Styles/theme';
import AppContainer from './AppContainer';
import AppContextProvider from './AppContextProvider';
import Auth0ProviderWithNavigate from './core/Auth0ProviderWithNavigate';
import queryClient from './core/queryClient';
import Store from './redux-flow/index.store';

const App = () => {
  // Initialize SomaDS
  useEffect(() => {
    SomaDS.use('xp');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Auth0ProviderWithNavigate>
          <Authorization>
            <Provider store={Store}>
              <ThemeProvider theme={Theme()}>
                <AppContextProvider>
                  <AppContainer />
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-left"
                  />
                </AppContextProvider>
              </ThemeProvider>
            </Provider>
          </Authorization>
        </Auth0ProviderWithNavigate>
      </HashRouter>
    </QueryClientProvider>
  );
};

export default App;
